/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var TenantUserMetaDataPolicy;
(function (TenantUserMetaDataPolicy) {
    TenantUserMetaDataPolicy[TenantUserMetaDataPolicy["TenantUserMetaDataPolicyNone"] = 1] = "TenantUserMetaDataPolicyNone";
    TenantUserMetaDataPolicy[TenantUserMetaDataPolicy["TenantUserMetaDataPolicySelf"] = 2] = "TenantUserMetaDataPolicySelf";
    TenantUserMetaDataPolicy[TenantUserMetaDataPolicy["TenantUserMetaDataPolicyAll"] = 4] = "TenantUserMetaDataPolicyAll";
})(TenantUserMetaDataPolicy || (TenantUserMetaDataPolicy = {}));
